import { Environment } from "../components"

const environment: any = new Environment()
environment.load()

export { environment }